import { Injectable } from '@angular/core';
import {
  BaseService, BaseStatistic,
  StatisticFilters,
  TournamentApi,
  TournamentSeasonApi,
} from '@mtgame/core';
import { Observable } from 'rxjs';
import { LeagueRootService } from '@core/services/league-root.service';

export const STORE_STATISTIC_KEY = 'statistic';

@Injectable()
export abstract class StatisticService extends BaseService {
  filters: StatisticFilters;

  abstract statistic$: Observable<BaseStatistic[]>;

  constructor(
    protected leagueRootService: LeagueRootService,
    protected tournamentApi: TournamentApi,
    protected tournamentSeasonApi: TournamentSeasonApi,
  ) {
    super();
  }

  async initialize(seasonId: number, tournamentId: number, round: number): Promise<void> {
    if (!seasonId) {
      const season = this.leagueRootService.getActiveSeasonModel();
      seasonId = season.id;
    }
    if (!tournamentId) {
      const tournament = this.leagueRootService.getActiveTournamentModel();
      if (tournament.season.id === seasonId) {
        tournamentId = tournament.id;
      } else {
        tournamentId = null;
      }
    }
    this.filters = {
      tournament_season_id: seasonId,
      tournament_id: tournamentId,
      tournament_round_id: round,
      group_by: 'team_user',
      per_game: false,
    };
  }

  abstract loadStatistic(): Promise<BaseStatistic[]>;

  async setFilter(filters: Partial<StatisticFilters>): Promise<any> {
    this.filters = {
      ...this.filters,
      ...filters,
    };
    await this.loadStatistic();
  }
}
